import React, { useState, useEffect } from "react";
import Header from "../../Components/Header";
import { Link } from "react-router-dom";
import cancel from "../../Assets/cancel.png";
import retry from "../../Assets/refresh.png";
import check from "../../Assets/check.png";
import "./Contact.css";

const Contact = () => {
  const [formInputs, setFormInputs] = useState({});
  const [status, setStatus] = useState("Submit");
  //state for math problem
  const [mathAsk, setMathAsk] = useState("");
  //state to check math solution
  const [mathNum, setMathNum] = useState("");
  //state to hold the result: check (pass) or retry (try again);
  const [mathChecked, setMathChecked] = useState("");
  //state to hold submit disabled vs submit enabled

  const handleChange = (e) => {
    const value = e.target.value;
    setFormInputs({
      ...formInputs,
      [e.target.name]: value,
    });
    console.log(formInputs);
  };

  function encode(data) {
    return Object.keys(data)
      .map(
        (key) =>
          encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
      )
      .join("&");
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    // code block below works when input tags have id instead of name
    // const { name, email, message, math } = e.target.elements;
    // let details = {
    //   name: name.value,
    //   email: email.value,
    //   message: message.value,
    //   math: math.value,
    // };
    // console.log(details);
    console.log(formInputs);
    // let response = await fetch("http://localhost:3000/contact", {
    // let response = await fetch("https://openmovies.netlify.app/contact", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json;charset=utf-8",
    //   },
    //   //   body: JSON.stringify(details),
    //   body: JSON.stringify(formInputs),
    // });
    let response = await fetch("/contact", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": "moviesContact",
        ...formInputs,
      }),
      // body: JSON.stringify(formInputs),
    })
      .then(() => console.log("success!"))
      .catch((error) => console.log(error));
    setStatus("Submit");
    console.log(response);
    // let result = await response.json();
    // alert(result.status);
    // console.log(result);
  };

  const askMath = () => {
    let num1 = Math.ceil(Math.random() * 10);
    let num2 = Math.ceil(Math.random() * 10);
    let total = num1 + num2;
    setMathAsk(`${num1} + ${num2} =`);
    console.log(num1, num2, total);
    setMathNum(total);
  };

  const handleMathChange = (e) => {
    e.preventDefault();
    let value = e.target.value;
    console.log(value);
    if (+value !== mathNum) {
      setMathChecked(cancel);
      console.log(value, mathNum, "cancel");
      console.log(formInputs);
    } else {
      setMathChecked(check);
      console.log(value, mathNum, "check");
      setFormInputs({ ...formInputs, math: `${mathAsk} ${mathNum}` });
      console.log(formInputs);
    }
  };

  const handleMathRefresh = () => {
    askMath();
  };

  useEffect(() => {
    askMath();
  }, []);

  return (
    <div>
      <Header title="Contact" />
      <form className="contact-form-wrapper" name="moviesContact" method="post" data-netlify="true"  netlify netlify-honeypot="bot-field" onSubmit={handleSubmit}>
      <input type="hidden" name="form-name" value="moviesContact" />
        <div>
          <input
            type="text"
            id="name"
            name="name"
            required
            placeholder="Name"
            onChange={handleChange}
          />
        </div>
        <div>
          <input
            type="email"
            id="email"
            name="email"
            required
            placeholder="Email"
            onChange={handleChange}
          />
        </div>
        <div>
          <textarea
            name="message"
            id="message"
            required
            placeholder="Message"
            onChange={handleChange}
          />
        </div>
        <div className="math-captcha-wrapper">
          <p>Please verify you are human.</p>
          <div className="math-wrapper">
            <label htmlFor="math">{mathAsk}</label>
            <input
              className="math-input"
              type="number"
              id="math"
              name="math"
              required
              onChange={handleMathChange}
            />
            <div className="math-icon-wrapper">
              {mathChecked === check ? (
                <>
                  <img src={check} alt="sum correct" />
                </>
              ) : mathChecked === cancel ? (
                <>
                  <img src={cancel} alt="sum incorrect" />{" "}
                  <img
                    src={retry}
                    alt="refresh math question"
                    onClick={handleMathRefresh}
                  />
                </>
              ) : null}
            </div>
          </div>
        </div>
        <p>
          Please see our <Link to="/privacy">Privacy Policy</Link> regarding how
          we will handle this information.
        </p>
        <div className="contact-form-submit-wrapper">
          {Object.keys(formInputs).length > 3 && mathChecked === check ? (
            <button className="btn btn-dark" type="submit">
              {status}
            </button>
          ) : (
            <button className="btn btn-light" type="submit" disabled>
              {status}
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default Contact;